module.exports = __webpack_public_path__ + "img/times.a8140391.svg";